export default __webpack_public_path__ + "static/media/InsideGerms_10.ae01a9ea.png";